module.exports = __webpack_public_path__ + "img/Frame 90.d11b3ff4.svg";